import React, { useState, useEffect, useContext } from 'react'
import GlobalEvents from '@src/utils/custom.event'
import { FETCH_STATUS } from '@src/constants/events'

type FeatchStatus = 'requestError' | 'abort' | 'failed' | 'error' | 'success'

type HandleFetchEvent =
  | CustomEvent<{ status: FeatchStatus }>
  | (Event & { detail?: { status: FeatchStatus } })

const OnlineStatusContext = React.createContext(true)

interface OwnProps {}

export type Props = OwnProps

const OnlineStatusProvider: React.FC<Props> = ({ children }) => {
  const [onlineStatus, setOnlineStatus] = useState<boolean>(true)

  const handleStatus = (status: boolean) => () => {
    setOnlineStatus(status)
  }

  const handleFetchStatus = ({ detail }: HandleFetchEvent) => {
    if (detail?.status === 'failed') {
      setOnlineStatus(false)
    }
    if (detail?.status === 'success' || detail?.status === 'requestError') {
      setOnlineStatus(true)
    }
  }

  useEffect(() => {
    GlobalEvents.on(FETCH_STATUS, handleFetchStatus)
    window.addEventListener('offline', handleStatus(false))
    window.addEventListener('online', handleStatus(true))

    return () => {
      GlobalEvents.off(FETCH_STATUS)
      window.removeEventListener('offline', handleStatus(false))
      window.removeEventListener('online', handleStatus(true))
    }
  }, [])

  return (
    <OnlineStatusContext.Provider value={onlineStatus}>
      {children}
    </OnlineStatusContext.Provider>
  )
}

export const useOnlineStatus = () => {
  const store = useContext(OnlineStatusContext)
  return store
}

export default OnlineStatusProvider
